import React, { Component } from 'react';
import styles from '../css/Submitted.module.css';
import SubmittedRecord from './SubmittedRecord';

class Submitted extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: props.data
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            this.setState({ data: this.props.data });
        }
    }

    render() {
        let temp = []
        if (this.props.data) {
            let reversed = this.props.data.slice().reverse()
           // let hash = {}
           // let parents = []
            for (let i = 0; i < reversed.length; i++) {
                temp.push(<SubmittedRecord key={crypto.randomUUID()} odd={i % 2 === 0 ? true : false} data={reversed[i]} setEditID={this.props.setEditID} />);
            }
           // for (let i = 0; i < parents.length; i++) {
          //      temp.push(<SubmittedRecord key={parents[i]} odd={i % 2 === 0 ? true : false} data={hash[parents[i]].record} setEditID={this.props.setEditID} />);
           // }
        }
        return (
            <div className={styles.submitted}>
                <div className={styles.titles}>

                </div>
                {temp.length > 0 ? temp : ""}
            </div>
        );
    }
}

export default Submitted;
